import React from 'react';
import {
  FlexColumn,
  FlexRow,
  formatHash,
  Text,
} from '@make-software/cspr-design';
import { HeaderText } from '@block-explorer/ui';

import PrevPageHeader from '../prev-page-header/prev-page-header';
import { getRouteDetails, useRouteMatchPath } from '../../router/utils';
import { useTranslation } from 'react-i18next';
import { deriveSplitDataFromNamedKeyValue } from '../../domain';

/* eslint-disable-next-line */
export interface BreadcrumbProps {
  prefix?: JSX.Element | null;
  suffix?: JSX.Element | string | null;
  children?: JSX.Element | null;
  headerActionComponent?: JSX.Element | null;
  hideHash?: boolean;
}

export function Breadcrumb(props: BreadcrumbProps) {
  const { t } = useTranslation();
  const { name, params } = getRouteDetails(useRouteMatchPath(), t);

  const hash = params.publicKey || params.id || '';

  const { hash: hashWithoutPrefix } = deriveSplitDataFromNamedKeyValue(hash);

  return (
    <FlexColumn itemsSpacing={8}>
      <PrevPageHeader />
      <FlexRow align={'center'} justify={'space-between'}>
        <HeaderText size={2} tag={'h1'}>
          {name} {props.prefix && props.prefix}
          {props.children || props.hideHash ? (
            props.children
          ) : (
            <Text monotype>{formatHash(hashWithoutPrefix)}</Text>
          )}
          {props.suffix}
        </HeaderText>
        {props.headerActionComponent}
      </FlexRow>
    </FlexColumn>
  );
}

export default Breadcrumb;
